import React, { useState } from 'react';
import { Form, Row, Col, Checkbox, Upload, Modal, message } from 'antd';
import { SimpleNumericInput, Table, Tooltip, Button, HeaderPage } from 'components';
import { useDispatch } from 'react-redux';
import { saveDevices } from 'actions/devices.actions';
import { blobWithCsv } from 'utils/file';
import Cookie from 'universal-cookie';
import { PlusOutlined, FormOutlined, InboxOutlined, DeleteOutlined } from '@ant-design/icons';
import './NuevoDispositivo.scss';

function NuevoDispositivo() {
  const [form] = Form.useForm();
  const [formModal] = Form.useForm();
  const { Dragger } = Upload;
  const [candidatos, setCandidatos] = useState([]);
  const [cargaMasiva, setCargaMasiva] = useState([]);
  const [open, setOpen] = useState(false);
  const [titulo, setTitulo] = useState('');
  const [tipoModal, setTipoModal] = useState(-1);
  const [toEdit, setToEdit] = useState(null);
  const [numKey, setNumKey] = useState(0);
  const [downloadingExcel, setDownloadingExcel] = useState(false);
  const [disableGuardar, setDisableGuardar] = useState(false);
  const uploadUrl = 'https://www.mocky.io/v2/5cc8019d300000980a055e76';
  let tokken = null;
  const coki = new Cookie();
  const dispatch = useDispatch();
  const [messageApi, contextHolder] = message.useMessage();

  function formatoFechaRegistro(now) {
    const options = {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'America/Mexico_City'
    };
    const dateInMexico = now.toLocaleString('es-ES', options);
    return dateInMexico;
  }

  const columns = [
    {
      title: 'IMEI',
      key: 'imei',
      dataIndex: 'imei',
      width: '21%',
      className: 'my-column-tbl'
    },
    {
      title: 'Número',
      dataIndex: 'numero',
      width: '20%',
      className: 'my-column-tbl'
    },
    {
      title: 'Activo',
      key: 'estatus',
      dataIndex: 'estatus',
      width: '10%',
      className: 'my-column-tbl',
      render: (record) => <div>{record === 1 ? <p>Sí</p> : <p>No</p>}</div>
    },
    {
      title: 'Fecha de registro',
      key: 'fechaHoraAlta',
      dataIndex: 'fechaHoraAlta',
      width: '30%',
      className: 'my-column-tbl',
      render: (record) => formatoFechaRegistro(record)
    },
    {
      title: 'Acciones',
      key: 'acciones',
      width: '15%',
      className: 'my-column-tbl',
      align: 'center',
      render: (_text, record) => (
        <div className="column-acciones">
          <Tooltip title="Editar" class="tooltip-acciones" placement="topLeft">
            <Button
              shape="circle"
              className="btnTblAccion"
              icon={<FormOutlined className="icons-tbl-users" />}
              onClick={() => {
                setOpen(true);
                setTitulo('Editar dispositivo');
                setTipoModal(1);
                formModal.setFieldsValue({
                  imei: record.imei,
                  numero: record.numero,
                  checkActivo: record.estatus
                });
                setToEdit(record);
              }}
            />
          </Tooltip>
          <Tooltip title="Eliminar" class="tooltip-acciones" placement="topLeft">
            <Button
              shape="circle"
              className="btnTblAccion"
              icon={<DeleteOutlined className="icons-tbl-users" />}
              onClick={() => {
                setOpen(true);
                setTitulo('');
                setTipoModal(0);
                setToEdit(record);
              }}
            />
          </Tooltip>
        </div>
      )
    }
  ];

  const onAgregar = (values) => {
    const now = new Date();
    setNumKey(numKey + 1);
    const newData = {
      key: numKey,
      imei: values.imei,
      numero: values.numero,
      estatus: values.checkActivo ? 1 : 0,
      fechaHoraAlta: now
    };
    setCandidatos([...candidatos, newData]);
    form.resetFields();
  };

  /**
   * Muestra un mensaje (alert) dependiendo de la respuesta del servidor.
   * @param {*} response
   */
  function showMessage(response) {
    if (response.data.imeiExistentes.length > 0) {
      if (response.data.idDisposGuardados.length > 1) {
        messageApi.success(
          `Los registros han sido guardados correctamente. Los imei que quiere capturar ya existen: 
          ${response.data.imeiExistentes.join(', ')}.`
        );
        form.resetFields();
        setCandidatos([]);
      } else if (response.data.idDisposGuardados.length === 1) {
        messageApi.success(
          `El registro ha sido guardado correctamente. Los imei que quiere capturar ya existen: 
          ${response.data.imeiExistentes.join(', ')}.`
        );
        form.resetFields();
        setCandidatos([]);
      } else {
        messageApi.info(`Los imei que quiere capturar ya existen: 
        ${response.data.imeiExistentes.join(',')}.`);
      }
    } else if (response.data.idDisposGuardados.length > 1) {
      messageApi.success('Los registros han sido guardados correctamente');
      form.resetFields();
      setCandidatos([]);
    } else if (response.data.idDisposGuardados.length === 1) {
      messageApi.success('El registro ha sido guardado correctamente');
      form.resetFields();
      setCandidatos([]);
    } else {
      messageApi.error('El registro no se ha podido guardar correctamente');
    }
  }

  const onSaveDispositivos = async () => {
    tokken = coki.get('JWT-TOKEN-SIMAC');
    if (candidatos.length === 0) {
      try {
        await form.validateFields();
        const now = new Date();
        setNumKey(numKey + 1);
        const newData = {
          key: numKey,
          imei: form.getFieldValue('imei'),
          numero: form.getFieldValue('numero'),
          estatus: form.getFieldValue('checkActivo') ? 1 : 0,
          fechaHoraAlta: now.toISOString()
        };
        const arrData = [newData];
        const { success, response } = await dispatch(
          saveDevices({
            nuevosDipositivos: arrData,
            token: tokken
          })
        );
        if (success && response?.data.code === 200) {
          if (response.data.imeiExistentes.length > 0) {
            messageApi.info(
              `El imei que quiere capturar ya existe:  ${response.data.imeiExistentes.join(', ')}`
            );
          } else {
            messageApi.success('El registro ha sido guardado correctamente');
            form.resetFields();
          }
        } else {
          messageApi.info(response.causa);
        }
      } catch (error) {
        /** Algún dato requerido no es correcto */
      }
    } else {
      for (let i = 0; i < candidatos.length; i += 1) {
        candidatos[i].fechaHoraAlta = candidatos[i].fechaHoraAlta.toISOString();
      }
      const { success, response } = await dispatch(
        saveDevices({
          nuevosDipositivos: candidatos,
          token: tokken
        })
      );
      for (let i = 0; i < candidatos.length; i += 1) {
        candidatos[i].fechaHoraAlta = new Date(candidatos[i].fechaHoraAlta);
      }
      if (success && response?.data.code === 200) {
        showMessage(response);
      } else if (candidatos.length === 1) {
        messageApi.info('El registro no se ha podido guardar correctamente');
      } else {
        messageApi.info('Los registros no se ha podido guardar correctamente');
      }
    }
  };

  /**
   * Funcionalidad del botón eliminar de la columna de acciones: elimina el elemento seleccionado.
   */
  const onEliminar = () => {
    const index = candidatos.indexOf(toEdit);
    if (index > -1) {
      candidatos.splice(index, 1);
    }
    setCandidatos([...candidatos]);
    setOpen(false);
  };

  const handleCancel = () => {
    formModal.resetFields();
    setToEdit(null);
    setOpen(false);
  };

  const onEditarDispo = () => {
    const index = candidatos.indexOf(toEdit);
    if (index > -1) {
      candidatos[index] = {
        imei: formModal.getFieldValue('imei'),
        numero: formModal.getFieldValue('numero'),
        estatus: formModal.getFieldValue('checkActivo') ? 1 : 0,
        fechaHoraAlta: new Date(),
        key: toEdit.key
      };
    }
    setCandidatos([...candidatos]);
    setToEdit(null);
    setOpen(false);
  };

  const handleDownloadPlantilla = () => {
    setDownloadingExcel(true);
    const url = window.URL.createObjectURL(
      blobWithCsv(['IMEI,NUMERO_TELEFONICO,DISPOSITIVO_ACTIVO'])
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'plantilla_dispositivos_simac.csv');
    link.click();
    setDownloadingExcel(false);
  };

  const handleBeforeUpload = (file) => {
    const isCSV = file.type === 'text/csv';
    if (!isCSV) {
      message.error('No se ha podido cargar el archivo. El formato no es compatible');
    }
    return isCSV || Upload.LIST_IGNORE;
  };

  const csvProps = {
    accept: '.csv',
    multiple: false,
    action: 'postDispos'
  };

  const handleFileChange = (info) => {
    setCargaMasiva([]);
    setDisableGuardar(true);
    const { file } = info;
    const reader = new FileReader();
    if (file.status === 'done' || file.status === 'error') {
      reader.onload = async (e) => {
        const contents = e.target.result;
        const header = contents.substr(0, contents.indexOf(','));
        const expectedHeader = 'IMEI';
        if (header !== expectedHeader) {
          message.error('No se ha podido cargar el archivo. El formato no es compatible');
          return;
        }
        const dataArr = contents.split(/[,\r\n]/);
        const cleanArray = dataArr.filter((value) => value.trim() !== '');
        const longitud = cleanArray.length;
        let i = 3;
        while (i < longitud) {
          const newData = {
            key: i,
            imei: Number(cleanArray[i]),
            numero: Number(cleanArray[i + 1]),
            estatus: Number(cleanArray[i + 2]),
            fechaHoraAlta: null
          };
          i += 3;
          cargaMasiva.push(newData);
        }
        setCargaMasiva(cargaMasiva);
        setDisableGuardar(false);
      };
      reader.readAsText(file.originFileObj);
    }
  };

  const onGuardarMasiva = async () => {
    tokken = coki.get('JWT-TOKEN-SIMAC');
    setDisableGuardar(true);
    const { success, response } = await dispatch(
      saveDevices({
        nuevosDipositivos: cargaMasiva,
        token: tokken
      })
    );
    if (success && response?.data.code === 200) {
      showMessage(response);
    } else if (response.causa) {
      messageApi.error(response.causa);
    } else {
      messageApi.error('Datos inválidos');
    }
    setDisableGuardar(false);
  };

  return (
    <div className="nuevoDispoContainer">
      <HeaderPage
        section=""
        section2="Nuevo dispositivos"
        title="Nuevos dispositivos"
        header="Agrega hasta cinco dispositivos"
      />
      {contextHolder}
      <Form layout="vertical" form={form} onFinish={onAgregar} disabled={candidatos.length >= 5}>
        <div className="section-inputs">
          <Form.Item
            name="imei"
            label="IMEI:"
            className=""
            rules={[
              { required: true, message: 'Dato requerido.' },
              { min: 15, message: 'IMEI debe contener 15 digitos' }
            ]}>
            <SimpleNumericInput maxLength={15} style={{ width: 300 }} />
          </Form.Item>
          <Form.Item
            name="numero"
            label="Número telefónico:"
            className=""
            rules={[
              { required: true, message: 'Dato requerido.' },
              { min: 10, message: 'Número telefónico debe contener 10 digitos' }
            ]}>
            <SimpleNumericInput maxLength={10} style={{ width: 300 }} />
          </Form.Item>
          <div className="checkBox-Button">
            <Form.Item name="checkActivo" label="Dispositivo activo" valuePropName="checked">
              <Checkbox />
            </Form.Item>
            <Button
              shape="circle"
              size="large"
              type="primary"
              htmlType="submit"
              icon={<PlusOutlined style={{ fontSize: '25px' }} />}
            />
          </div>
        </div>
      </Form>
      {candidatos.length > 0 ? (
        <div id="tabla">
          <h3 className="title-h3">Dispositivos por agregar</h3>
          <div>
            <Table
              // rowKey={(record) => record}
              style={{ marginBottom: '20px' }}
              bordered={false}
              columns={columns}
              dataSource={candidatos}
              pagination={false}
            />
          </div>
        </div>
      ) : null}
      {open ? (
        <Modal
          title={titulo}
          open={open}
          onCancel={handleCancel}
          centered
          width={tipoModal === 1 ? '68%' : '24%'}
          wrapClassName="modal-simac"
          className={tipoModal === 1 ? 'modal-editar' : 'modal-eliminar'}
          footer={null}>
          {tipoModal === 1 ? (
            <div id="formulario">
              <Form
                id="formEditDevice"
                layout="vertical"
                form={formModal}
                onFinish={onEditarDispo}
                className="form-modal">
                <Row gutter={[10, 24]} style={{ width: '90%' }}>
                  <Col span={8}>
                    <Form.Item
                      name="imei"
                      label="IMEI:"
                      rules={[{ required: true, message: 'Dato requerido.' }]}>
                      <SimpleNumericInput maxLength={15} style={{ width: '94%' }} />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="numero"
                      label="Número telefónico:"
                      rules={[{ required: true, message: 'Dato requerido.' }]}>
                      <SimpleNumericInput maxLength={10} style={{ width: '94%' }} />
                    </Form.Item>
                  </Col>
                  <Col span={6} className="check-dis-activo">
                    <Form.Item name="checkActivo" valuePropName="checked">
                      <Checkbox>Dispositivo activo</Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="center-element" style={{ margin: '13px' }}>
                  <Col span={24}>
                    <Form.Item>
                      <Button text="Guardar" type="primary" htmlType="submit" />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </div>
          ) : (
            <div className="center-element" style={{ flexDirection: 'column' }}>
              <p>¿Deseas eliminar el registro?</p>
              <Button text="Aceptar" type="primary" onClick={onEliminar} />
            </div>
          )}
        </Modal>
      ) : null}
      <div className="div-btnguardar">
        <Button type="primary" text="Guardar" onClick={onSaveDispositivos} />
      </div>
      <div id="carga">
        <h3 className="title-h3" style={{ marginBottom: 0 }}>
          Carga masiva
        </h3>
        <span className="instruction-span">
          Para realizar una carga masiva de dispositivos utiliza la plantilla del sistema.
        </span>
        <div>
          <Button
            type="primary"
            text="Descargar plantilla"
            disabled={downloadingExcel}
            onClick={handleDownloadPlantilla}
            style={{ marginTop: '20px', marginBottom: '20px' }}
          />
        </div>
        <div className="div-dragger dispos-dragger">
          <Dragger
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...csvProps}
            beforeUpload={handleBeforeUpload}
            onChange={handleFileChange}
            action={uploadUrl}
            maxCount={1}>
            <p className="ant-upload-drag-icon icon-inbox">
              <InboxOutlined className="icon-inbox" />
            </p>
            <p className="color-p-dragger">
              Da clic o arrastra el archivo a esta área para cargarlo
            </p>
          </Dragger>
        </div>
        <Button
          style={{ marginTop: '20px', marginBottom: '20px' }}
          type="primary"
          text="Guardar"
          onClick={onGuardarMasiva}
          disabled={disableGuardar}
        />
      </div>
    </div>
  );
}

export default NuevoDispositivo;
